import { t } from "../i18n/ui";
type Theme = "light" | "dark";

const KEY = "otridon:theme";
const root = document.documentElement;
const currentTheme = (): Theme => (root.dataset.theme === "dark" ? "dark" : "light");

function apply(theme: Theme): void {
  if (currentTheme() === theme && root.dataset.theme) return;
  root.classList.add("is-theming");
  root.dataset.theme = theme;
  paintBar();
  window.setTimeout(() => root.classList.remove("is-theming"), 600);
  document.querySelectorAll<HTMLButtonElement>("[data-theme-toggle]").forEach((b) => label(b));
  window.dispatchEvent(new CustomEvent<Theme>("otridon:theme", { detail: theme }));
}

function label(button: HTMLButtonElement): void {
  const dark = currentTheme() === "dark";
  button.setAttribute("aria-pressed", String(dark));
  button.setAttribute("aria-label", dark ? t("Switch to light mode") : t("Switch to dark mode"));
  button.title = dark ? t("Light mode") : t("Dark mode");
  document.querySelectorAll<HTMLElement>("[data-theme-label]").forEach((el) => {
    el.textContent = dark ? t("Light mode") : t("Dark mode");
  });
}

function paintBar(): void {
  const bar = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (bar) bar.content = currentTheme() === "dark" ? "#0f2422" : "#84C3BE";
}

export function initTheme(): void {
  if (!root.dataset.theme) root.dataset.theme = "light";
  paintBar();
  document.querySelectorAll<HTMLButtonElement>("[data-theme-toggle]").forEach((button) => {
    label(button);
    button.addEventListener("click", () => {
      const next: Theme = currentTheme() === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(KEY, next);
      } catch {
      }
      apply(next);
    });
  });
}
